export enum CommonErrorStatus {
  SVC_LOGO_EXCEEDED_FILE_SIZE = -4001300, // 이용기관 로고 > 허용되지 않는 로고 파일 용량 입니다.
  SVC_LOGO_NOT_ALLOWED_FILE_FORMAT = -4001302, // 이용기관 로고 & CI문서 > 허용되지 않는 로고 포맷 입니다.

  CI_DOC_EXCEEDED_FILE_COUNT = -4001304, // CI문서 > 허용되지 않는 ci 문서 파일 갯수 입니다.
  CI_DOC_EXCEEDED_FILE_SIZE = -4001305, // CI문서 > 허용되지 않는 ci 문서 용량 입니다.
  CI_DOC_NOT_ALLOWED_FILE_FORMAT = -4001306, // 허용되지 않는 ci 문서 포맷 입니다.
  CI_DOC_FILE_REQUIRED = -4000612, // ci docs 파일이 필요합니다.

  APP_ICON_EXCEEDED_FILE_SIZE = -4001307, // 앱 아이콘 > 허용되지 않는 앱아이콘 용량 입니다.
  APP_ICON_NOT_ALLOWED_FILE_FORMAT = -4001308, // 앱 아이폰 > 허용되지 않는 앱아이콘 포맷 입니다.

  ALIM_TALK_IMAGE_EXCEEDED_FILE_SIZE = -4001309, // 허용되지 않는 알림톡 이미지 파일 용량 입니다.
  ALIM_TALK_IMAGE_NOT_ALLOWED_FILE_FORMAT = -4001311, // 허용되지 않는 알림톡 이미지 포맷 입니다.

  SETTLE_ADJUST_REQUEST_EXCEEDED_FILE_COUNT = -4001312, // 정산내역 조정요청 > 허용되지 않는 조정 요청자료 파일 갯수 입니다.
  SETTLE_ADJUST_REQUEST_EXCEEDED_FILE_SIZE = -4001313, // 정산내역 조정요청 > 허용되지 않는 조정 요청자료 용량 입니다.
  SETTLE_ADJUST_REQUEST_NOT_ALLOWED_FILE_FORMAT = -4001314 // 정산내역 조정요청 > 허용되지 않는 조정 요청자료 포맷 입니다.
}
